var React = require('react');

function StatThreeOne (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.911132 15.2178C0.911133 6.93351 7.62686 0.217773 15.9111 0.217773C24.1954 0.217773 30.9111 6.9335 30.9111 15.2178L30.9111 244.608H0.911127L0.911132 15.2178Z","fill":"url(#paint0_linear_501_1725)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_501_1725","x1":"15.9111","y1":"0.217773","x2":"15.9111","y2":"244.608","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.15625","stopColor":"#FFFCF3","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#FFFCF3","stopOpacity":"0","key":1})]))]);
}

StatThreeOne.defaultProps = {"width":"31","height":"245","viewBox":"0 0 31 245","fill":"none"};

module.exports = StatThreeOne;

StatThreeOne.default = StatThreeOne;
